import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
import ivyPlayer from '@/commons/ivyPlayer.vue';
import { addStatistics } from '../require';
let HeadPicture = class HeadPicture extends Vue {
    constructor() {
        super(...arguments);
        this.newTime = Date.now();
        this.videoPlaying = false;
        this.pageNow = 1;
    }
    get showSaleCount() {
        let { invitation } = this.$route.query;
        return !!invitation;
    }
    get descTip() {
        return this.spuId === 10544 ? '人已浏览' : '人已购买';
    }
    pageChange(index) {
        this.pageNow = index + 1;
        // 埋点 头图切换
        addStatistics({
            event: 'Click_GoodDetails_Change_HeadPicture',
            p1: this.point,
            p2: this.goodsStatus,
        });
    }
    playVideo() {
        this.videoPlaying = true;
        let ivyBtnEl = document.querySelector('.ivy-btn-play');
        ivyBtnEl && ivyBtnEl.click();
        // 埋点 头图视频点击播放
        addStatistics({
            event: 'Click_GoodDetails_PlayVideo',
            p1: this.point,
            p2: this.video,
            p3: this.goodsStatus,
        });
    }
    closeVideo(val) {
        this.videoPlaying = false;
        this.newTime = Date.now();
        // 埋点 播放时长
        addStatistics({
            event: 'GoodDetails_VideoPlayTime',
            p1: this.point,
            p2: this.video,
            p3: Math.floor(val),
            p4: this.goodsStatus,
        });
    }
    sendAddStatistics(time, percent) {
        // 埋点 播放时长
        addStatistics({
            event: 'GoodDetails_VideoPlayTime',
            p1: this.point,
            p2: this.video,
            p3: Math.floor(time),
            p4: this.goodsStatus,
        });
    }
};
tslib_1.__decorate([
    Prop({ default: [] })
], HeadPicture.prototype, "imgs", void 0);
tslib_1.__decorate([
    Prop()
], HeadPicture.prototype, "video", void 0);
tslib_1.__decorate([
    Prop()
], HeadPicture.prototype, "saleCount", void 0);
tslib_1.__decorate([
    Prop()
], HeadPicture.prototype, "hasActivity", void 0);
tslib_1.__decorate([
    Prop()
], HeadPicture.prototype, "point", void 0);
tslib_1.__decorate([
    Prop()
], HeadPicture.prototype, "goodsStatus", void 0);
tslib_1.__decorate([
    Prop()
], HeadPicture.prototype, "spuId", void 0);
HeadPicture = tslib_1.__decorate([
    Component({
        name: 'HeadPicture',
        components: {
            ivyPlayer,
        },
    })
], HeadPicture);
export default HeadPicture;
